module.exports = __webpack_public_path__ + "img/section1SwiperTab4.56ee680d.png";